import React, {Component, Fragment} from 'react';

class CustomFragment extends Component {
    render = () => (<Fragment/>);
}

export default CustomFragment;